export interface passwordValidationDemandsSchema {
	label: string
	passed: boolean
}

export const formState = ref<{ password: string }>({
	password: ''
})

export const passwordValidationDemands = ref([
	{
		label: 'Both upperCase and lowerCase letters',
		passed: false
	},
	{
		label: 'At least 8-12 characters long',
		passed: false
	},
	{
		label: 'Special characters and numbers',
		passed: false
	}
])
export const validatePassword = (arg: Array<passwordValidationDemandsSchema>) => {
	arg[0].passed = /[a-z]/.test(formState.value.password) && /[A-Z]/.test(formState.value.password)
	arg[1].passed = formState.value.password.length >= 8
	arg[2].passed =
		/[0-9]/.test(formState.value.password) && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formState.value.password)
}
export const passwordRulePass = computed(() => {
	return passwordValidationDemands.value.every(i => i.passed === true)
})
export const setPassWord = computed({
	set(val: string) {
		formState.value.password = val
		validatePassword(passwordValidationDemands.value)
	},
	get() {
		return formState.value.password
	}
})
